export const sessionKey: string = "crmMsalAuthSession";
export const sessionExpiryKey: string = "crmExpiryTime";
